module.exports = __webpack_public_path__ + "img/qr_wx.1eb3f2f6.png";